import { render, staticRenderFns } from "./BudgetType.vue?vue&type=template&id=28e16690&scoped=true"
import script from "./BudgetType.vue?vue&type=script&lang=js"
export * from "./BudgetType.vue?vue&type=script&lang=js"
import style0 from "./BudgetType.vue?vue&type=style&index=0&id=28e16690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e16690",
  null
  
)

export default component.exports